export const CLIENT_CONFIG_DEFAULTS = {
  elementId: null,
  // all limits that are arrays should always consist of integers
  limits: {
    brandId: [],
    dataSpeedGen: [],
    offerExtraId: [],
    phoneId: [],
    phoneOperatingSystemId: [],
    phoneVariantEan: [],
    phoneVariantId: [],
    providerId: [],
    shopId: [],
    sponsoredPositionId: []
  },
  options: {
    abTesting: true,
    clickOutParams: null,
    clickOutsInNewWindow: true,
    fullComparatorUrl: null,
    inGoogleAmp: false,
    inIframe: false,
    label: null,
    language: null,
    languageUpdates: {}, // here every i18n namespace key can be overwritten
    showFullComparatorLink: true,
    showSponsoredPositions: true,
    themeIdentifier: null,
    themeVariable: null,
    updateUrl: false
  },
  portal: null,
  token: ""
};
